import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminUser, AdminUsers, AdminUsersState } from 'Interfaces/Admin';

const INITIAL_STATE: AdminUsersState = {
  loaded: false,
  collection: [],
};

const adminUsersSlice = createSlice({
  name: 'adminUsers',
  initialState: INITIAL_STATE,
  reducers: {
    loadedAdminUsers(state, action: PayloadAction<AdminUsers>) {
      return { loaded: true, collection: action.payload };
    },
    /** Merges a reloaded list over the current one, keeping unseen users. */
    mergeAdminUsers(state, action: PayloadAction<AdminUsers>) {
      const byId = new Map(state.collection.map((u) => [u.id, u]));
      action.payload.forEach((u) => byId.set(u.id, { ...byId.get(u.id), ...u }));
      return { loaded: true, collection: Array.from(byId.values()) };
    },
    upsertAdminUser(state, action: PayloadAction<AdminUser>) {
      const user = action.payload;
      const index = state.collection.findIndex((u) => u.id === user.id);
      if (index === -1) {
        state.collection.push(user);
      } else {
        state.collection[index] = { ...state.collection[index], ...user };
      }
    },
    deactivateAdminUsers(state, action: PayloadAction<number[]>) {
      const ids = action.payload;
      state.collection = state.collection.map((u) =>
        ids.includes(u.id) ? { ...u, active: false } : u,
      );
    },
  },
});

export const {
  loadedAdminUsers, mergeAdminUsers, upsertAdminUser, deactivateAdminUsers,
} = adminUsersSlice.actions;

export default adminUsersSlice.reducer;
